<script setup lang="ts">
import { BlueMarble } from '@/layouts'
import SignUpPage from './SignUpPage.vue'
</script>

<template>
  <BlueMarble>
    <div class="w-full bg-card text-foreground rounded-2xl border border-border shadow-[0_40px_100px_-15px_rgba(0,0,0,0.9),0_0_120px_-20px_rgba(255,255,255,0.15)] px-5 py-5 overflow-hidden">
      <SignUpPage />
    </div>
  </BlueMarble>
</template>
